<div class="monthly-trend-panel">
    <div class="monthly-trend-content">
        <div class="monthly-trend-container">
            <form [formGroup]="selectedYears"
                    [connectForm]="form$ | async">
                <mat-form-field>
                <mat-label>Years:</mat-label>
                    <mat-select formControlName="years" multiple>
                        @for (year of getYears(); track year) {
                            <mat-option [value]="year">
                            {{ year }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </form>

            @if (isLoading$ | async) {
                <div class="monthly-trend-loading">
                    <mat-spinner diameter="48"></mat-spinner>
                </div>
            } @else {
                <ag-charts
                    class="monthly-trend-chart"
                    [options]="options"
                    ></ag-charts>

                <div class="monthly-trend-table-container">
                    <table class="monthly-trend-table">
                        <thead>
                            <tr>
                                <th>Month</th>
                                <th>Numerator</th>
                                <th>Denominator</th>
                                <th>Rate (%)</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of tableRows$ | async; track row.monthLabel) {
                                <tr>
                                    <td>{{ row.monthLabel }}</td>
                                    <td>{{ row.numerator }}</td>
                                    <td>{{ row.denominator }}</td>
                                    <td>{{ row.rateDisplay }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    </div>
</div>
